import React, { useState, useContext } from 'react'
import { TabsWrapper, TabsList, Tab } from '@livechat/design-system'
import { AuthContext } from '../contexts/auth'
import Account from './Account'
import Settings from './Settings'
import Routing from './Routing'
import Tutorial from './Tutorial'

const Tabs = ({ groups, onDisconnected }) => {
  const [activeTab, setActiveTab] = useState('routing')
  const [numberOfRoutes, setNumberOfRoutes] = useState(0)
  const auth = useContext(AuthContext)

  return (
    <div>
      <TabsWrapper>
        <TabsList>
          <Tab
            onClick={() => setActiveTab('routing')}
            isSelected={activeTab === 'routing'}
            description={numberOfRoutes}
          >
            Notifications
          </Tab>

          <Tab
            onClick={() => setActiveTab('settings')}
            isSelected={activeTab === 'settings'}
          >
            Settings
          </Tab>

          <Tab
            onClick={() => setActiveTab('account')}
            isSelected={activeTab === 'account'}
          >
            Account
          </Tab>

          <Tab
            onClick={() => setActiveTab('tutorial')}
            isSelected={activeTab === 'tutorial'}
          >
            How it works
          </Tab>
        </TabsList>
      </TabsWrapper>

      {activeTab === 'routing' && (
        <Routing
          auth={auth}
          groups={groups}
          onNotificationsLoad={setNumberOfRoutes}
        />
      )}

      {activeTab === 'settings' && <Settings auth={auth} />}

      {activeTab === 'account' && (
        <Account auth={auth} onDisconnected={onDisconnected} />
      )}

      {activeTab === 'tutorial' && <Tutorial />}
    </div>
  )
}

export default Tabs
